// extracted by mini-css-extract-plugin
module.exports = {"form":"GroupCompanySettingForm__form--3-dqT","isDisplayGroupCompanySetting":"GroupCompanySettingForm__isDisplayGroupCompanySetting--2YDM3"};